import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaLock,
  FaShieldAlt,
  FaRocket,
  FaShoppingCart,
  FaUserShield,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const SecureEcommerceWebsiteDevelopmentInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Secure E-commerce Website Development in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Safety First, Sales Always</Subheading>}
        heading={
          <Heading>
            Secure{" "}
            <span tw="text-primary-500">E-commerce Website Development</span> in
            Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in secure e-commerce website
            development in **Bur Dubai**, building online stores with top-tier
            security features to protect your business and customers. Launch a
            safe, trusted platform that drives sales with confidence.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Secure e-commerce shopping
          "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Digital security concept
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Team working on web development
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Secure Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Secure E-commerce Development in Bur Dubai"
        description="We prioritize security to safeguard your online business."
        cards={[
          {
            icon: <FaLock color="#ff5464" size={40} />,
            title: "Top-Tier Security",
            description: "SSL, encryption, and secure payment gateways.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Data Protection",
            description: "Safeguard customer info with robust measures.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast & Secure",
            description: "Speed without compromising safety.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Trusted Shopping",
            description: "Build customer trust with a secure platform.",
          },
          {
            icon: <FaUserShield color="#ff5464" size={40} />,
            title: "Compliance Ready",
            description: "Adhere to global e-commerce security standards.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Proven Reliability",
            description:
              "Trusted by Bur Dubai businesses for secure solutions.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Secure Development Process"
        description={
          <Description>
            We build secure e-commerce websites with a meticulous approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Planning: Assess your security and business needs.</li>
              <li>Design: Create a secure, user-friendly interface.</li>
              <li>Development: Implement encryption and secure frameworks.</li>
              <li>Testing: Conduct rigorous security and performance tests.</li>
              <li>Launch: Deploy with SSL and ongoing monitoring.</li>
              <li>Support: Provide updates to maintain top security.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1566669437687-7040a6926753?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Secure checkout process
          "https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Security monitoring dashboard
          "https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Development team collaboration
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Secure E-commerce Wins in Bur Dubai"
        description="Our secure websites have delivered peace of mind and results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Safe Sales",
            description: "Doubled sales with a secure, trusted store.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Zero Breaches",
            description: "Protected a retailer from threats for 2+ years.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "97% satisfaction from secure e-commerce clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for a Secure Store?</Subheading>}
        heading="Secure E-commerce Development in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for secure e-commerce website
            development in Bur Dubai. Protect your business and customers with a
            robust, high-performing online store—start today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Team celebrating project success
          "https://images.unsplash.com/photo-1557821552-17105176677c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // E-commerce payment security
          "https://images.unsplash.com/photo-1535303311164-664fc9ec6532?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Dubai cityscape
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
